import { Card, Tag, Text } from '@sede-enterprise/shell-ds-react-framework'
import React from 'react'

const CategoryLegend = ({ greenLabel, amberLabel, redLabel }) => {
    return (
        <Card bodyPadding={false} className='legend-container' elevated={false}>
            <div className='legend-item-container'>
                {greenLabel && <div className='legend-item'>
                    <Tag className='category-tip'
                        sentiment='positive'
                        variant='outlined'
                        size='small'
                        shape='round'
                    >
                        GREEN
                    </Tag>
                    <Text size='small'>{greenLabel}</Text>
                </div>}

                {amberLabel && <div className='legend-item'>
                    <Tag className='category-tip'
                        sentiment='warning'
                        variant='outlined'
                        size='small'
                        shape='round'
                    >
                        AMBER
                    </Tag>
                    <Text size='small'>{amberLabel}</Text>
                </div>}

                {
                    redLabel && <div className='legend-item'>
                        <Tag className='category-tip'
                            sentiment='negative'
                            variant='outlined'
                            size='small'
                            shape='round'
                        >
                            RED
                        </Tag>
                        <Text size='small'>{redLabel}</Text>
                    </div>
                }

            </div>
        </Card >
    )
}

export default CategoryLegend